import React from "react";
import {Container} from "semantic-ui-react";

export const Banner = props => {
    const {children, className, style, verticalAlign} = props;

    return (
        <React.Fragment>
            <Container fluid className={`content ${verticalAlign ? `v-align ${verticalAlign}` : ''}`}>
                <Container className={className} style={style}>
                    {children}
                </Container>
            </Container>
        </React.Fragment>
    );
};
